(function(scope){
  'use strict';
  const validHandle=value=>typeof value==='string'&&/^[a-z0-9][a-z0-9®-]*$/.test(value);
  const normalize=raw=>Array.isArray(raw)?[...new Set(raw.filter(validHandle))].slice(0,3):[];
  function summary(product){
    const variants=Array.isArray(product.variants)?product.variants:[],available=variants.filter(v=>v.available===true),prices=variants.map(v=>v.price).filter(value=>typeof value==='number'&&Number.isFinite(value)&&value>=0);
    const optionValues=pattern=>{
      const index=(product.options||[]).findIndex(o=>pattern.test(typeof o==='string'?o:o.name||''));
      return index<0?[]:[...new Set(available.map(v=>v.options?.[index]).filter(Boolean))];
    };
    return {inStock:available.length>0,minimum:prices.length?Math.min(...prices):null,maximum:prices.length?Math.max(...prices):null,sizes:optionValues(/size|taille|mărime/i),colors:optionValues(/colou?r/i),vendor:product.vendor||'',type:product.type||''};
  }
  function createSelection(limit=3){
    const selected=new Map(),pending=new Map();
    const reserve=handle=>{
      if(!validHandle(handle)||selected.has(handle)||pending.has(handle)||selected.size+pending.size>=limit)return null;
      const token={handle};pending.set(handle,token);return token;
    };
    const commit=(token,product)=>{
      if(!token||pending.get(token.handle)!==token)return false;
      pending.delete(token.handle);
      if(product?.handle!==token.handle||!Array.isArray(product.variants)||!product.variants.length)return false;
      selected.set(token.handle,product);return true;
    };
    const release=token=>{if(token&&pending.get(token.handle)===token)pending.delete(token.handle);};
    const remove=handle=>{pending.delete(handle);selected.delete(handle);};
    const clear=()=>{pending.clear();selected.clear();};
    const replace=(handle,product)=>{if(selected.has(handle)&&product?.handle===handle&&Array.isArray(product.variants)&&product.variants.length)selected.set(handle,product);};
    return {reserve,commit,release,remove,clear,replace,handles:()=>[...selected.keys()],products:()=>[...selected.values()],has:handle=>selected.has(handle),isPending:handle=>pending.has(handle)};
  }
  const api={validHandle,normalize,summary,createSelection};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  if(scope)scope.MotionCompareCore=api;
})(typeof window!=='undefined'?window:null);
